module.exports = __webpack_public_path__ + "img/ic_insights_opened.aed1d81c.png";